export default {"src":"/_next/static/media/link.7f62da07.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};